module.exports = __webpack_public_path__ + "img/mechanic.7cb6e67f.png";